import {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import {set} from 'date-fns';
import DateSelectContext from '../../context';
import {getSafeDate} from '../../utils';

const ButtonToday = () => {
    const {onChange, value} = useContext(DateSelectContext);
    const {t} = useTranslation();

    const onClick = () => {
        if (value) {
            onChange(
                set(new Date(), {
                    hours: value.getHours(),
                    minutes: value.getMinutes(),
                }),
            );
        } else {
            onChange(getSafeDate(new Date()));
        }
    };

    return (
        <Button
            className="w-full border-solid"
            kind="secondary"
            onClick={onClick}
            size="sm"
        >
            {t('form:today')}
        </Button>
    );
};

export default ButtonToday;
